/*
 * Živá aktualizace košíku — jedno místo pro všechny funkce, které do košíku
 * něco přidávají (cross-sell, rychlé objednání, pravidelná objednávka, dárek).
 *
 * Dřív si každá funkce přepisovala počet v hlavičce sama a cena zůstávala
 * stará až do obnovení stránky. Teď se po každé změně košíku:
 *   1. přepíše počet i částka v hlavičce
 *   2. na stránce košíku se překreslí obsah bez načtení stránky
 *
 * Volání: window.ilicoKosik.obnov()
 */
(function () {
  'use strict';
  if (window.ilicoKosik) return;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function penize(halere) {
    try {
      return new Intl.NumberFormat('cs-CZ', {
        style: 'currency', currency: 'CZK', maximumFractionDigits: 0
      }).format(halere / 100);
    } catch (e) {
      return Math.round(halere / 100) + ' Kč';
    }
  }

  function hlavicka(cart) {
    document.querySelectorAll('[data-kosik-pocet], .ilico-evo-header__cart-count:not([data-oblibene-pocet]), .head-slot-cart-link-quantity')
      .forEach(function (el) { el.textContent = cart.item_count; });

    document.querySelectorAll('[data-kosik-cena]')
      .forEach(function (el) { el.textContent = penize(cart.total_price); });

    document.querySelectorAll('.head-slot-cart-link .head-slot-nav-link-label')
      .forEach(function (el) { el.textContent = '(' + penize(cart.total_price) + ')'; });
  }

  /*
   * Obsah košíku natáhneme přes Section Rendering API a vyměníme jen
   * vnitřek sekce. Načtení celé stránky by odscrollovalo nahoru a blikalo.
   */
  function prekresliKosik() {
    var sekce = document.querySelector('#shopify-section-evo_cart, [id^="shopify-section-"] .ilico-evo-cart');
    if (!sekce) return Promise.resolve(false);

    var wrapper = sekce.closest('[id^="shopify-section-"]') || sekce;
    var id = (wrapper.id || '').replace('shopify-section-', '');
    if (!id) return Promise.resolve(false);

    return fetch(rootUrl + 'cart?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return false;
        var novy = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('#shopify-section-' + id);
        if (!novy) return false;
        var preserved = ['[data-cart-b2b]', '.ilico-evo-cart__note', 'cart-coupon'].map(function (selector) {
          return { selector: selector, element: wrapper.querySelector(selector) };
        });
        wrapper.innerHTML = novy.innerHTML;
        preserved.forEach(function (entry) {
          var replacement = wrapper.querySelector(entry.selector);
          if (replacement && entry.element) replacement.replaceWith(entry.element);
        });
        fitSummary();

        /* Nově vložený obsah potřebuje znovu navázat obsluhu. */
        document.dispatchEvent(new CustomEvent('ilico:kosik-prekreslen'));
        return true;
      })
      .catch(function () { return false; });
  }

  function obnov(prekreslit) {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(reconcileGift)
      .then(function (cart) {
        hlavicka(cart);
        document.dispatchEvent(new CustomEvent('ilico:kosik-zmena', { detail: cart }));
        if (prekreslit !== false && document.querySelector('[data-ilico-darek], .ilico-evo-cart')) {
          return prekresliKosik().then(function () { return cart; });
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  function reconcileGift(cart) {
    if (!window.ilicoDarek || !window.ilicoDarek.srovnej) return Promise.resolve(cart);
    return window.ilicoDarek.srovnej({ cart: cart, refresh: false }).then(function (changed) {
      if (!changed) return cart;
      return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error((window.cartStrings && window.cartStrings.error) || 'Košík se nepodařilo načíst.');
        return response.json();
      });
    });
  }

  window.ilicoKosik = { obnov: obnov, penize: penize, prekresli: prekresliKosik, aktualizuj: hlavicka };

  var pending = new Map();
  var timer;
  var updating = false;
  var noteRequest = Promise.resolve();
  var noteSaving = 0;

  function cartRoot() { return document.querySelector('.ilico-evo-cart'); }

  function fitSummary() {
    var root = cartRoot();
    var summary = root && root.querySelector('.ilico-evo-cart__summary');
    var scroll = root && root.querySelector('[data-evo-summary-scroll]');
    if (!summary) return;
    if (window.innerWidth <= 1100) {
      summary.style.removeProperty('--evo-summary-height');
      summary.removeAttribute('data-evo-scroll');
      return;
    }
    var previewBar = document.getElementById('PBarNextFrame') ? 56 : 0;
    summary.style.setProperty('--evo-summary-height', Math.max(150, window.innerHeight - 124 - previewBar) + 'px');
    if (scroll) {
      var overflow = scroll.scrollHeight - scroll.clientHeight;
      summary.dataset.evoScroll = overflow <= 2 ? 'none' : scroll.scrollTop >= overflow - 2 ? 'end' : 'more';
    }
  }

  window.addEventListener('resize', fitSummary);
  document.addEventListener('scroll', function (event) {
    if (event.target.matches && event.target.matches('[data-evo-summary-scroll]')) fitSummary();
  }, true);
  document.addEventListener('toggle', function (event) {
    if (event.target.closest('.ilico-evo-cart')) requestAnimationFrame(fitSummary);
  }, true);

  function checkoutBusy(busy) {
    if (!busy && (updating || pending.size || noteSaving)) return;
    var root = cartRoot();
    if (!root) return;
    root.querySelectorAll('[name="checkout"]').forEach(function (button) {
      if (busy) {
        if (!button.hasAttribute('data-cart-was-disabled')) button.dataset.cartWasDisabled = String(button.disabled);
        button.disabled = true;
      } else if (button.hasAttribute('data-cart-was-disabled')) {
        button.disabled = button.dataset.cartWasDisabled === 'true';
        delete button.dataset.cartWasDisabled;
      }
    });
  }

  function showError(message) {
    var root = cartRoot();
    if (!root) return;
    var error = root.querySelector('[data-cart-update-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.cartUpdateError = '';
      error.className = 'form-status form-status-error';
      error.setAttribute('role', 'alert');
      root.prepend(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }

  function flush() {
    if (updating || !pending.size) return;
    updating = true;
    var changes = Array.from(pending);
    pending.clear();
    var root = cartRoot();
    root.setAttribute('aria-busy', 'true');
    var controls = Array.from(root.querySelectorAll('[data-evo-cart-qty], [data-evo-cart-step]'));
    controls.forEach(function (control) { control.disabled = true; });
    var active = document.activeElement;
    var activeName = active && active.name;
    var latest;
    changes.reduce(function (chain, change) {
      return chain.then(function () {
        return fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: change[0], quantity: change[1] })
        }).then(function (response) {
          return response.json().then(function (cart) {
            if (!response.ok || cart.errors || cart.status) throw new Error(cart.description || cart.errors || (window.cartStrings && window.cartStrings.error));
            latest = cart;
          });
        });
      });
    }, noteRequest).then(function () {
      return reconcileGift(latest);
    }).then(function (cart) {
      latest = cart;
      hlavicka(latest);
      document.dispatchEvent(new CustomEvent('ilico:kosik-zmena', { detail: latest }));
      var mini = document.querySelector('mini-cart');
      if (mini) Promise.resolve(mini.updateSectionContents()).catch(function () {});
      return prekresliKosik().then(function (rendered) {
        if (!rendered) throw new Error((window.cartStrings && window.cartStrings.error) || 'Košík se nepodařilo načíst. Obnovte stránku.');
        var nextRoot = cartRoot();
        var input = Array.from(nextRoot.querySelectorAll('[data-evo-cart-qty]')).find(function (element) { return element.name === activeName; });
        if (input) input.focus({ preventScroll: true });
      });
    }).catch(function (error) {
      return obnov(false).then(prekresliKosik).then(function () {
        showError(error.message || (window.cartStrings && window.cartStrings.error) || 'Košík se nepodařilo aktualizovat. Zkuste to znovu.');
      });
    }).finally(function () {
      updating = false;
      controls.forEach(function (control) { control.disabled = false; });
      if (cartRoot()) cartRoot().removeAttribute('aria-busy');
      checkoutBusy(false);
      if (pending.size) flush();
    });
  }

  function queue(input, quantity) {
    var match = input.name.match(/^updates\[(.+)\]$/);
    if (!match || updating) return;
    if (!Number.isInteger(quantity) || quantity < 0 || input.value === '') {
      input.value = input.defaultValue;
      showError((window.cartStrings && window.cartStrings.error) || 'Zadejte celé nezáporné množství.');
      return;
    }
    showError('');
    pending.set(match[1], quantity);
    checkoutBusy(true);
    clearTimeout(timer);
    timer = setTimeout(flush, 150);
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('.ilico-evo-cart [data-evo-cart-step]');
    if (step) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (updating || step.disabled) return;
      var input = step.parentElement.querySelector('[data-evo-cart-qty]');
      if (!input) return;
      input.value = Math.max(0, Number(input.value) + Number(step.dataset.evoCartStep));
      queue(input, Number(input.value));
      return;
    }
    var remove = event.target.closest('.ilico-evo-cart a[href*="/cart/change"]');
    if (!remove || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url = new URL(remove.href);
    if (url.searchParams.get('quantity') !== '0' || !url.searchParams.get('id')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (updating) return;
    pending.set(url.searchParams.get('id'), 0);
    checkoutBusy(true);
    clearTimeout(timer);
    timer = setTimeout(flush, 150);
  }, true);

  ['change', 'keydown'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var input = event.target.closest('.ilico-evo-cart [data-evo-cart-qty]');
      if (!input || (name === 'keydown' && event.key !== 'Enter')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      queue(input, Number(input.value));
    }, true);
  });

  document.addEventListener('change', function (event) {
    var note = event.target.closest('.ilico-evo-cart textarea[name="note"]');
    if (!note) return;
    event.stopImmediatePropagation();
    var value = note.value;
    noteSaving++;
    checkoutBusy(true);
    noteRequest = noteRequest.then(function () {
      return fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: value })
      }).then(function (response) {
        if (!response.ok) throw new Error((window.cartStrings && window.cartStrings.error) || 'Poznámku se nepodařilo uložit. Zkuste to znovu.');
      });
    }).catch(function (error) {
      showError(error.message);
    }).finally(function () {
      noteSaving--;
      checkoutBusy(false);
    });
  }, true);
})();
